import { propagateEvents } from '@tunein/web-utils';
import { EventEmitter } from 'eventemitter3';
import { RequestClient } from '../RequestClient';
import { StoreClient } from '../StoreClient';
import { AuthService, ConfigService, StreamsService, TelemetryService, UIService, UserService, } from '../services';
export class ApiClient extends EventEmitter {
    #requestClient;
    #storeClient;
    #services = {};
    constructor(options) {
        super();
        this.#storeClient = new StoreClient(options);
        this.#requestClient = new RequestClient(this.#storeClient);
        propagateEvents({ from: this.#requestClient, to: this });
        this.on('error', (event) => {
            this.telemetry.logError(event);
        });
    }
    get graphQlSdk() {
        return this.#requestClient.graphQlSdk;
    }
    get authTokens() {
        return this.#requestClient.authTokens;
    }
    set authTokens(authTokens) {
        this.#requestClient.authTokens = authTokens;
    }
    get hasAuthTokens() {
        return this.#requestClient.hasAuthTokens;
    }
    get partnerId() {
        return this.#storeClient.options.partnerId;
    }
    get isPremium() {
        return this.#storeClient.isPremium;
    }
    get locationData() {
        return this.#storeClient.locationData;
    }
    get adsTargeting() {
        return this.#storeClient.adsTargeting;
    }
    get reportingContext() {
        return this.#storeClient.reportingContext;
    }
    get config() {
        if (!this.#services.config) {
            this.#services.config = new ConfigService(this.#requestClient, this.#storeClient);
        }
        return this.#services.config;
    }
    get user() {
        if (!this.#services.user) {
            this.#services.user = new UserService(this.#requestClient, this.#storeClient);
        }
        return this.#services.user;
    }
    get auth() {
        if (!this.#services.auth) {
            this.#services.auth = new AuthService(this.#requestClient, this.#storeClient);
        }
        return this.#services.auth;
    }
    get ui() {
        if (!this.#services.ui) {
            this.#services.ui = new UIService(this.#requestClient, this.#storeClient);
        }
        return this.#services.ui;
    }
    get streams() {
        if (!this.#services.streams) {
            this.#services.streams = new StreamsService(this.#requestClient, this.#storeClient);
        }
        return this.#services.streams;
    }
    get telemetry() {
        if (!this.#services.telemetry) {
            this.#services.telemetry = new TelemetryService(this.#requestClient, this.#storeClient);
        }
        return this.#services.telemetry;
    }
    updateOptions(options) {
        this.#storeClient.updateOptions(options);
        if (options.requestHeaders) {
            this.#requestClient.updateHeaders(this.#storeClient.options.requestHeaders);
        }
        if (options.ipAddress) {
            this.#requestClient.updateHeaders({
                'x-forwarded-for': options.ipAddress,
            });
        }
    }
    getConfigSetting = (key, fallback) => {
        return this.#storeClient.getConfigSetting(key, fallback);
    };
    updateReportingContext(context) {
        this.#storeClient.updateReportingContext(context);
    }
}
